import React from 'react';

const Notification = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FB8B01"
        d="M12 2a3 3 0 0 1 2.993 2.799A5.998 5.998 0 0 1 18 10v4a2 2 0 1 1 0 4H6a2 2 0 1 1 0-4v-4a5.998 5.998 0 0 1 3.007-5.201A3 3 0 0 1 12 2zm3 17a3 3 0 0 1-6 0h6z"
      />
    </g>
  </svg>
);

export default Notification;
